<div [ngStyle]="styleOptions" [class.blink-animation]="useBlinkAnimation">
    <h2>{{ message }}</h2>
</div>